import Investment from "./Investment";

export default Investment;
